import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import '../src/Utils/UI/Utils.css'
import store from './Utils/Redux/Store/store'
import { Provider } from 'react-redux'
import { SnackbarProvider, useSnackbar } from 'notistack'

const SnackbarCloseButton = ({ snackbarKey }) => {
    const { closeSnackbar } = useSnackbar()

    return (
        <button
            onClick={() => closeSnackbar(snackbarKey)}
            style={{
                border: 'none',
                background: 'transparent',
                color: 'white',
                cursor: 'pointer',
                marginLeft: 10,
            }}
        >
            ✖
        </button>
    )
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <SnackbarProvider
                maxSnack={4}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
            >
                <App />
            </SnackbarProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister()
